<template>
  <span :class="style.heading">Telegram</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Введите название"
      description="Название группы"
      v-model="localIntegration.name"
    />
    <InputStyle
      size="M"
      placeholder="Имя заявки"
      description="Введите имя заявки"
      v-model="localIntegration.nameApp"
      v-if="edit"
    />
    <InputStyle
      size="M"
      placeholder="Введите ID"
      description="ID группы"
      v-model="localIntegration.id"
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import style from "./settingIntegrations.module.scss";
import {defineComponent, PropType} from "vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {telegramIntegration} from "@/page/setting/integration/IntegrationTypes";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationTelegram",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integration: {
      type: Object as PropType<telegramIntegration>,
      default: () => ({})
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        name: this.integration?.name || "",
        id: String(this.integration?.id ?? ""),
        nameApp: this.integration?.nameApp || ""
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.telegram;

      if (!integration) return;

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = {
          ...this.localIntegration
        };
      } else {
        integration.integration.push({...this.localIntegration});
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          name: newVal.name || "",
          id: String(newVal.id ?? ""),
          nameApp: newVal.nameApp || ""
        };
      }
    }
  }
});
</script>
